import { Tooltip, Typography } from '@mui/joy';
import { Info } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Color, Level } from 'theme/enums';

export const AllowedDecimalsTooltip = ({ decimals }: { decimals: number }) => {
  const { t } = useTranslation();

  const title = (
    <Typography level={Level.BODY_XS} color={Color.WARNING}>
      {t('titleAllowedDecimals', { decimals })}
    </Typography>
  );

  if (!decimals) {
    return null;
  }

  return (
    <Tooltip title={title}>
      <Info />
    </Tooltip>
  );
};
